import script from "./ShippingDetailsV2.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShippingDetailsV2.vue?vue&type=script&setup=true&lang=ts"

import "./ShippingDetailsV2.vue?vue&type=style&index=0&id=37f3b05a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37f3b05a"]])

export default __exports__